import request from '@/utils/request'

const getGoodsInfoById = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/goods-info/${id}`,
    method: 'get'
  })
}

const getGoodsInfoPageList = (query) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/goods-info/page-list`,
    method: 'get',
    params: query
  })
}

const queryGoodsList = (query) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/goods-info`,
    method: 'get',
    params: query
  })
}

function createGoodsInfo(data) {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/goods-info`,
    method: 'post',
    data
  })
}

const updateGoodsInfo = (id, data) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/goods-info/${id}`,
    method: 'put',
    data
  })
}

export default {
  createGoodsInfo,
  updateGoodsInfo,
  getGoodsInfoById,
  getGoodsInfoPageList,
  queryGoodsList
}
